export { default as Rooms } from './container';
